module.exports = __webpack_public_path__ + "BannerSecundario_SmallCells.jpg?2897035ded8b45201c147e61b5cd26d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/BannerSecundario_SmallCells.jpg
// module id = 200
// module chunks = 0